// extracted by mini-css-extract-plugin
export default {"container":"ColorPicker_container__hSPax","preview":"ColorPicker_preview__hi5lP"};